/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div id="app" class="theme-vieWide">
    <no-ssr>
      <vue-progress-bar></vue-progress-bar>
    </no-ssr>
    <app-view />
  </div>
</template>

<script>
import AppView from 'theme/AppView.vue'
import MetaHelper from '@/helpers/Meta'

export default {
  head () {
    const metaHelper = new MetaHelper(this.$store)
    const metaRobots = metaHelper.getRobots()
    const skipSanitize = {}

    const dinamicObj = {
      // titleTemplate: title => title ? `${title} | ${Package.name}` : Package.name,
      titleTemplate: title => title || metaHelper.getTitle(),
      htmlAttrs: {
        lang: this.$store.getters['ui/language']
      },
      bodyAttrs: {
        class: this.$store.getters['ui/blockScrollbar'] ? 'overflow-hidden' : ''
      },
      meta: [
        { charset: 'utf-8' },
        { 'http-equiv': 'content-type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=no' },
        { name: 'robots', content: metaRobots },
        { name: 'msapplication-TileColor', content: '#ffffff' },
        { name: 'theme-color', content: '#ffffff' },
        { name: 'application-name', content: 'Coin' },
        { name: 'apple-mobile-web-app-title', content: 'Coin' },
        { name: 'apple-mobile-web-app-status-bar-style', content: 'transparent' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' }
      ],
      link: [
        { rel: 'manifest', href: '/manifest.json' },
        { rel: 'mask-icon', href: '/icon/safari-pinned-tab.svg', color: '#000000' },
        { rel: 'icon', href: '/icon/favicon-32x32.png', type: 'image/png', sizes: '32x32' },
        { rel: 'icon', href: '/icon/favicon-16x16.png', type: 'image/png', sizes: '16x16' },
        { rel: 'apple-touch-icon', sizes: '152x152', href: '/icon/apple-touch-icon-ipad.png' },
        { rel: 'apple-touch-icon', sizes: '167x167', href: '/icon/apple-touch-icon-ipad-retina.png' },
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/icon/apple-touch-icon.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/12.9__iPad_Pro_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/11__iPad_Pro__10.5__iPad_Pro_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/10.5__iPad_Air_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/10.2__iPad_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/9.7__iPad_Pro__7.9__iPad_mini__9.7__iPad_Air__9.7__iPad_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)', href: '/splash-screens/iPhone_13_Pro_Max__iPhone_12_Pro_Max_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)', href: '/splash-screens/iPhone_13_Pro__iPhone_13__iPhone_12_Pro__iPhone_12_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)', href: '/splash-screens/iPhone_13_mini__iPhone_12_mini__iPhone_11_Pro__iPhone_XS__iPhone_X_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)', href: '/splash-screens/iPhone_11_Pro_Max__iPhone_XS_Max_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/iPhone_11__iPhone_XR_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)', href: '/splash-screens/iPhone_8_Plus__iPhone_7_Plus__iPhone_6s_Plus__iPhone_6_Plus_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/iPhone_8__iPhone_7__iPhone_6s__iPhone_6__4.7__iPhone_SE_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)', href: '/splash-screens/4__iPhone_SE__iPod_touch_5th_generation_and_later_landscape.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/12.9__iPad_Pro_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/11__iPad_Pro__10.5__iPad_Pro_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/10.5__iPad_Air_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/10.2__iPad_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/9.7__iPad_Pro__7.9__iPad_mini__9.7__iPad_Air__9.7__iPad_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)', href: '/splash-screens/iPhone_13_Pro_Max__iPhone_12_Pro_Max_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)', href: '/splash-screens/iPhone_13_Pro__iPhone_13__iPhone_12_Pro__iPhone_12_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)', href: '/splash-screens/iPhone_13_mini__iPhone_12_mini__iPhone_11_Pro__iPhone_XS__iPhone_X_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)', href: '/splash-screens/iPhone_11_Pro_Max__iPhone_XS_Max_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/iPhone_11__iPhone_XR_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)', href: '/splash-screens/iPhone_8_Plus__iPhone_7_Plus__iPhone_6s_Plus__iPhone_6_Plus_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/iPhone_8__iPhone_7__iPhone_6s__iPhone_6__4.7__iPhone_SE_portrait.png' },
        { rel: 'apple-touch-startup-image', media: 'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)', href: '/splash-screens/4__iPhone_SE__iPod_touch_5th_generation_and_later_portrait.png' }
        // { rel: 'stylesheet', href: Config.API.cms.styleLib }
      ],
      noscript: [
        { innerHTML: 'This website requires JavaScript.' }
      ]
    }
    // remove escape
    if (Object.keys(skipSanitize).length) {
      dinamicObj.__dangerouslyDisableSanitizersByTagID = {}
      for (let tagID in skipSanitize) {
        dinamicObj.__dangerouslyDisableSanitizersByTagID[tagID] = skipSanitize[tagID]
      }
    }
    return dinamicObj
  },
  methods: {
    init () {
      this.$gmapApiPromiseLazy()
    }
  },
  mounted () {
    this.init()
    // load data from localstorage
    if (this.$store.state.ui.redirect) {
      if (this.$store.state.ui.redirect.indexOf('?') !== -1) {
        location.href = this.$store.state.ui.redirect
      } else {
        location.href = this.$store.state.ui.redirect + location.search
      }
    }
    Promise.all([
      this.$store.dispatch('userAdmin/init'),
      this.$store.dispatch('cart/init')
    ]).then(() => {
      this.$store.dispatch('ui/init')
    })
  },
  components: {
    AppView
  }
}
</script>
